import * as React from "react";

const ScheduledIcon = (props: { color?: string; size?: number; isNewTable?: boolean }): JSX.Element => {
    const size = props.size ?? 14;
    const color = props.color ?? "#767676";

    if (props.isNewTable) {
        return (
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 2C6.4772 2 2 6.47721 2 12C2 17.5228 6.4772 22 12 22C17.5229 22 22 17.5228 22 12C22 6.47721 17.523 2 12 2ZM14.9929 14.9691C14.6676 15.2944 14.14 15.2944 13.8147 14.9691L11.1673 12.3216V7.8368C11.1673 7.37682 11.5402 7.00383 12.0002 7.00383C12.2302 7.00383 12.4385 7.09707 12.5891 7.2477C12.7397 7.39833 12.8332 7.60681 12.8332 7.8368V11.6314L14.9929 13.7911C15.3182 14.1165 15.3182 14.644 14.9929 14.9691Z"
                    fill={color}
                />
            </svg>
        );
    }
    return (
        <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7 0C3.13404 0 0 3.134 0 6.99992C0 10.8658 3.13404 13.9998 7 13.9998C10.866 13.9998 14 10.8658 14 6.99992C14 3.134 10.8661 0 7 0ZM9.09503 9.07824C8.8673 9.30596 8.49802 9.30596 8.2703 9.07824L6.41709 7.22505V4.0857C6.41709 3.76372 6.67817 3.50263 7.00016 3.50263C7.16116 3.50263 7.30693 3.5679 7.41236 3.67334C7.5178 3.77878 7.58324 3.92471 7.58324 4.0857V6.74191L9.09503 8.25368C9.32275 8.4814 9.32275 8.85068 9.09503 9.07824Z"
                fill={color}
            />
        </svg>
    );
};

export default ScheduledIcon;
